import React from "react"

import { window, document } from 'browser-monads';
import styled from 'styled-components'
import he from 'he';
import { useState, useRef, useEffect } from "react"


const { localStorage } = window;


const DivShareWeb = styled.div`
  // display: none;
  text-align: center;
  /*width: 300px;height: fit-content;background: white;*/
  background: white;
  position: absolute;
  right: 0;
  top: 0;
  // margin-top: 80px;
  background-color: #ffffff;
  height: 58px;
  width: fit-content;
  border-radius: 29px;
  /*-moz-box-shadow: 7px 7px 31px -12px rgba(0,0,0,0.8);
box-shadow: 7px 7px 31px -12px rgba(0,0,0,0.8);*/
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.5);
  padding-top: 6px;
  padding-left: 10px;
  padding-right: 10px;

  @media only screen and (max-width: 640px) {
    right: -80px;
  }
`

function ShareLink ({
    // components_name_md5,
    // share_url,
    img_src,
    img_alt,
    href,
    a_id,
    aria_label
  }) {

  return (
    <a
      id={a_id}
      className="resp-sharing-button__link"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={aria_label}
    >
      <div className={"resp-sharing-button resp-sharing-button--" + img_alt + " resp-sharing-button--medium"}>
        <div aria-hidden="true" className="resp-sharing-button__icon resp-sharing-button__icon--solid">
          <img alt={img_alt} src={img_src}/>
        </div>
      </div>
    </a>
  )
}

function ShareButton ({
    components_name_md5,
    title,
    url
  }) {

  const node = useRef()
  let _share_url = encodeURIComponent(window.location.href);
  try {
    if (url && url.startsWith('/'))
      _share_url = encodeURIComponent(
        new URL(`${window.location.protocol}//${window.location.host}${url}`)
      );
    else{
      _share_url = encodeURIComponent(new URL(url));
    }
  } catch (error) {
  }
  let _share_text = "";

  var convertedValue;
  try {
    convertedValue = he.decode(title);
    _share_text = convertedValue;
  }catch (error) {
    _share_text = "";
  }

  const [isOpenModal, setIsOpenModal] = useState(false);
  const share_text = _share_text;
  const share_url = _share_url;

  function decodeHTML(html) {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  async function share() {
    if (navigator.share === undefined) {
      //window.alert('not ye');
    } else {
      //window.alert('share ok');
      var title, text;

      try {
        title =  decodeHTML(document.querySelectorAll('meta[property="og:title"]')[0].content);
      } catch (erro) {}

      try {
        text = decodeHTML(document.querySelectorAll('meta[property="og:title"]')[0].content) + "  \n"+window.location.href;
      } catch (erro) {
        if (title)
        text = title + " " +window.location.href;
        else
        text = window.location.href;
      }

      var url = window.location.href;
      var files = undefined;

      if (files && files.length > 0) {
        if (!navigator.canShare || !navigator.canShare({files})) {
          //window.alert('Error: Unsupported feature: navigator.canShare()');
          document.getElementsByClassName('share_web_icon')[0].classList.add('sharethis-inline-share-buttons')
          return;
        }
      }

      try {
        await navigator.share({files, title, text, url});
        //window.alert('Successfully sent share');
        if (localStorage.getItem("success_share")===null) {
          localStorage.setItem("success_share",1)
        } else {
          localStorage.setItem("success_share",parseInt(localStorage.getItem('font_size'))+1);
        }

        localStorage.setItem("share_"+window.location.href,Date.now() / 1000 | 0);
      } catch (error) {
        //window.alert('Error sharing: ' + error);
        localStorage.setItem("sharetentaive_"+window.location.href,Date.now() / 1000 | 0);
      }
    }
  }

  function toggle_share (components_name_md5) {

    if (window.innerWidth<=500 && navigator.share !== undefined) {
      //native sharer
      share();
    } else {
      setIsOpenModal(!isOpenModal)
      // if (window.document.getElementById("div_shareeweb"+components_name_md5).style.display === "block") {
      //   window.document.getElementById("div_shareeweb"+components_name_md5).style.display = "none";
      //   try {
      //     window.document.getElementById("div_fontsize_wrapper"+components_name_md5).style.display = "none";
      //   } catch (err) {
      //     console.debug('No to close other modal', err)
      //   }
      // } else {
      //   window.document.getElementById("div_shareeweb"+components_name_md5).style.display = "block";
      //   try {
      //     window.document.getElementById("div_fontsize_wrapper"+components_name_md5).style.display = "block";
      //   } catch (err) {
      //     console.debug('No to close other modal', err)
      //   }
      // }
    }
  }

  const handleClick = e => {
    if (node.current.contains(e.target)) {
      return;
    }
    setIsOpenModal(false);
  };

  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    }
  }, [])

  return (
    <div
      ref={node}
      role="button"
      tabIndex="0"
      id={"newmag_social_share_web" + components_name_md5}
      className="newmag_social_share_web"
      style={{ cursor: "pointer", display: "inline-block" }}
      alt="Share article"
      onClick={() => toggle_share(components_name_md5)}
      onKeyDown={(event) => {
        if (event.key === "Enter") toggle_share(components_name_md5)
      }}
    >
      <img
        className="icon_share share_icons"
        alt="Share article"
        src="/img/share_copy_3@2x.svg"
        style={{ marginTop: "7px", width: "27px", height: "auto" }}
      />
      {/*
      <div>{share_text}</div>
      <div>{share_url}</div>
      */}
      {!isOpenModal ? (
        ""
      ) : (
        <div style={{ position: "relative" }}>
          <DivShareWeb
            id={"div_shareeweb" + components_name_md5}
            className="div_shareeweb"
            style={{ zIndex: "2" }}
          >
            <div
              style={{
                display: "flex",
                position: "relative",
                top: 0,
                right: 0,
                height: "50px",
              }}
            >
              <ShareLink
                img_src="/img/facebook@2x.png"
                img_alt="facebook"
                href={
                  "https://facebook.com/dialog/share?app_id=2736511256363790&display=popup&link=" +
                  share_url +
                  "&href=" +
                  share_url +
                  "&redirect_uri=" +
                  share_url
                }
                a_id={"div_shareeweb_fb" + components_name_md5}
                aria_label="Facebook"
              />

              <ShareLink
                img_src="/img/twitter@2x.png"
                img_alt="twitter"
                href={
                  "https://twitter.com/intent/tweet/?text=" +
                  share_text +
                  "&url=" +
                  share_url
                }
                a_id={"div_shareeweb_tw" + components_name_md5}
                aria_label="Twitter"
              />

              <ShareLink
                img_src="/img/mail@2x.png"
                img_alt="email"
                href={"mailto:?subject=" + share_text + "&body=" + share_url}
                a_id={"div_shareeweb_em" + components_name_md5}
                aria_label="E-Mail"
              />

              <ShareLink
                a_id={"div_shareeweb_ln" + components_name_md5}
                href={
                  "https://www.linkedin.com/shareArticle?mini=true&url=" +
                  share_url +
                  "&title=" +
                  share_text +
                  "&summary=" +
                  share_text +
                  "&source=" +
                  share_url
                }
                aria_label="LinkedIn"
                img_alt="linkedin"
                img_src="/img/linkedin@2x.png"
              />

              <ShareLink
                a_id={"div_shareeweb_wa" + components_name_md5}
                href={"whatsapp://send?text=" + share_text + "%20" + share_url}
                aria_label="WhatsApp"
                img_alt="whatsapp"
                img_src="/img/whatsapp@2x.png"
              />

              <ShareLink
                a_id={"div_shareeweb_tl" + components_name_md5}
                href={
                  "https://telegram.me/share/url?text=" +
                  share_text +
                  "&url=" +
                  share_url
                }
                aria_label="Telegram"
                img_alt="telegram"
                img_src="/img/telegram@2x.png"
              />

              <ShareLink
                a_id={"div_shareeweb_tl" + components_name_md5}
                href={
                  "https://share.flipboard.com/bookmarklet/popout?v=2&title=" +
                  title +
                  "&url=" +
                  share_url
                }
                // href={"https://telegram.me/share/url?text="+share_text+"&url="+share_url}
                aria_label="Flipboard"
                img_alt="flipboard"
                img_src="/img/flipboard blue@2x.png"
              />
            </div>
          </DivShareWeb>
        </div>
      )}
    </div>
  )
}

export default ShareButton;
